export default __webpack_public_path__ + "static/media/Icon8.9ca1b0f9.svg";